export const DEFAULT_MEAL_TIMES = { breakfast: '07:30', lunch: '12:00', dinner: '18:30' };

/**
 * Convert 24-hour time string to 12-hour format.
 * "18:30" → "6:30 PM"
 */
export function formatMealTime(time24) {
  const [h, m] = time24.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
}

/**
 * Subtract prep + cook time from target meal time.
 * Returns formatted 12-hour string, e.g. "5:45 PM".
 */
export function getStartByTime(mealTime24, prepMin, cookMin) {
  const totalMin = (prepMin || 0) + (cookMin || 0);
  if (totalMin <= 0) return null;

  const [h, m] = mealTime24.split(':').map(Number);
  let minutes = h * 60 + m - totalMin;
  if (minutes < 0) minutes += 24 * 60;

  const startH = Math.floor(minutes / 60) % 24;
  const startM = minutes % 60;
  const period = startH >= 12 ? 'PM' : 'AM';
  const hour12 = startH === 0 ? 12 : startH > 12 ? startH - 12 : startH;
  return `${hour12}:${String(startM).padStart(2, '0')} ${period}`;
}
